import { BatchPhotoCaptureConfig, BatchPhotoUploadResult } from '@services/camera/CameraTypes';

export abstract class AbstractCameraCaptureAdapter {
    public abstract captureImage(config: any): Promise<any>;
    public abstract captureImageAndUpload(config: any): Promise<any>;

    /**
     * Captures several photos in one native session and uploads each one.
     *
     * Implemented on the cross-frame path; the Velocity adapter rejects, having no camera bridge.
     * Consult {@link AbstractCameraCaptureAdapter.isBatchCaptureImplemented} before calling.
     *
     * @param config - per-photo capture settings plus the batch-only fields.
     */
    public abstract captureImagesAndUpload(config: BatchPhotoCaptureConfig): Promise<BatchPhotoUploadResult>;

    /**
     * Whether {@link AbstractCameraCaptureAdapter.captureImagesAndUpload} will actually attempt a
     * capture on this adapter, as opposed to rejecting outright.
     *
     * Synchronous by design: answering it must not cost a cross-frame round trip, because an
     * unanswerable request would sit for the full response timeout before failing.
     */
    public abstract isBatchCaptureImplemented(): boolean;
}
